/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IgUserDto } from '../../models/ig-user-dto';

export interface GetProfileData$Params {
}

export function getProfileData(http: HttpClient, rootUrl: string, params?: GetProfileData$Params, context?: HttpContext): Observable<StrictHttpResponse<IgUserDto>> {
  const rb = new RequestBuilder(rootUrl, getProfileData.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IgUserDto>;
    })
  );
}

getProfileData.PATH = '/api/v1/instagram/profile';
